import { addressFormSX } from '@/components/blocks/AddressForm/styles/form';
import { mergeSx } from '@/utils/mergeSx';
import { Stack, SxProps, Theme } from '@mui/material';

type Props = {
	formRef?: React.RefObject<HTMLFormElement>;
	onSubmit?: React.FormEventHandler<HTMLFormElement>;
	children: React.ReactNode;
	id?: string;
	sx?: SxProps<Theme>;
};

export const AddressFormContainer = ({ formRef, onSubmit, children, id, sx }: Props) => (
	<Stack
		spacing={1.875}
		component="form"
		noValidate
		onSubmit={onSubmit}
		ref={formRef}
		id={id}
		sx={mergeSx(addressFormSX, sx)}
	>
		{children}
	</Stack>
);
